<template>
  <div>

        <v-container>


          <v-row class="mt-0 pt-0 mb-0 pb-0">
            <l-map v-if="swipeDirection!='Up'" ref="map" :zoom="zoom" :center="center" :options="mapOptions"
              style="height: 85vh;z-index: 2;position:absolute;bottom:0px;left: 0;overflow-y: hidden;">
              <l-tile-layer :url="url" />
              <l-control-zoom position="bottomleft"  ></l-control-zoom>
              <l-control v-if="userLocation!=null" position="bottomright">
                <v-btn class="floatingBtn" icon large>
                  <a
                    :href="'https://www.google.com/maps/dir/?api=1&origin=' + userLocation.lat + ',' + userLocation.lng + '&destination='+ marker.lat + ','+ marker.lng +'&travelmode=walking'">
                    <img style="width:6vh" :src="require('@/assets/direction2.png')" />
                  </a>
                </v-btn>
              </l-control>

              <l-marker v-if="userLocation!=null" :lat-lng="userLocation">
                <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]" :icon-size="[1,1]">
                  <img style="width:3vh" :src="require('@/assets/account.png')" />
                </l-icon>
              </l-marker>




              <l-marker v-for="singleStory in getCurrentAllPublicStories" :key="singleStory.id" :lat-lng="{'lat':singleStory.latitude,'lng':singleStory.longitude}">
                <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]">
                  <v-icon color="primaryVariant" class="mr-2">mdi-map-marker</v-icon>
                </l-icon>
              </l-marker>
              <!-- user position take from db-->

              <l-marker v-if="this.marker!=null" :lat-lng="this.marker">
                <l-icon :iconSize="[24, 24]" :iconAnchor="[12, 24]">
                  <v-icon color="darkOrange" class="mr-2">mdi-map-marker</v-icon>
                </l-icon>
              </l-marker>
            </l-map>
          </v-row>

        </v-container>
 
  </div>
</template>

<script>
import {
  Touch
} from "vuetify/lib/directives"

import dialogMixin from "vue-dialog-mixin"
import 'leaflet/dist/leaflet.css';
//import {latLng} from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LControl,
  LControlZoom
} from "vue2-leaflet";
export default {
  name: "singleStoryMapView",
  mixins: [dialogMixin],
  data() {
    return {
      swipeDirection: 'None',
      model: null,
      apiUrl: process.env.VUE_APP_ROOT_API,

      userLocation: null,
      maploaded: false,
      cache: {},
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      staticAnchor: [16, 37],
      zoom: 10,

      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      currentZoom: 8,
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        zoomControl: false
      },
      showMap: true,
    }
  },
  directives: {
    Touch
  },
  components: {

    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LControl,
    LControlZoom
  },
  async mounted() {
    this.center = this.getSingleStoryGeolocalizationOnMap
    
    this.userLocation = {
      lat: this.$store.getters.getUser.latitude,
      lng: this.$store.getters.getUser.longitude
    }
this.$getLocation()
  .then(response => {
    let coordinates=response
if (coordinates!=null&&typeof coordinates!="undefined"){
      this.userLocation = {
        lat: coordinates.lat,
        lng: coordinates.lng
      }
    }
  });

  },
  computed: {
    center: {
      get: function () {
        return this.$store.getters.getSingleStoryGeolocalizationOnMap;
      }
    },
    marker: {
      get: function () {
        return this.$store.getters.getSingleStoryGeolocalizationOnMap;
      }
    },
    getCurrentAllPublicStories: {
      get: function () {
        return this.$store.getters.getCurrentAllPublicStories;
      }
    }
    },
  methods: {
    openDialogDetail (){
      console.log("clicked")
      this.dielogDetail = true;
      alert("click")
    },
    swipe(direction) {
      this.swipeDirection = direction
    },


    waitFunction() {
      //this is a workaround for the map to load correctly since the leaflet component has a bug
      setTimeout(() => {
        this.$refs.map.mapObject.invalidateSize()
      }, 100)
    },
    retrivePositionMarkerPlace: async function (markerposition) {
      try {
        return this.getaxiosResponse(this.apiUrl + '/getGeoLocationInfo?lat=' + markerposition.lat + '&lon=' + markerposition.lng)
      } catch (error) {
        if (error.status === 400) {
          // Handle error.
        }
        // Handle error.
        else {
          console.log(error);
        }
      }
    },
  }
}
</script>

<style scoped>
.address{
width: 15rem;
font-size: 0.6rem;
}
.styleMapAddress{
  font-size: 0.8rem;
}
.maxwidth{
  width:200px;
}
.sliderCoverImg{
    width: 100%;
    height: auto;
    max-width: 200px;
    box-sizing:content-box;
}
.v-application p{
  margin-bottom: 0px;
}
.uppercase--text{
  text-transform: uppercase;
}
.breakWord{
  font-size: 65%;
     overflow-wrap: break-word;
     max-width: 40vh;
}
.square {
      border-radius:5%;
      border:2px solid black;
min-width: 20vh;
min-height: 20vh;
word-wrap: break-word;
  background-color: #888;
}
.circle {
  height: 5vh;
  width: 5vh;
  background-color: #555;
  border-radius: 50%;
}
</style>